
import { Field, Transaction, type ITransaction } from '../../../core/domain/module';
import { Step } from '../../../core/domain/transaction/step';
import { DismissibleErrors, Messages, Routes } from '../../../core/enums/module';
import { Analytics, InternalEventNames, Steps } from '../../../core/services/analytics/module';
import { Auth } from '../../../core/services/auth/auth';
import { FieldTypes } from '../../fieldTypes';
import { required } from '../../fieldValidations/module';
import { DefaultSteps } from '../../default';
import { Subscriptions } from '../../../core/services/module';
import { resolveMemberBrand } from '../../../utilities/resolveMemberBrand';
import { shouldUseCabelasBranding } from '../../../utilities/shouldUseCabelasBranding';
import { Brands } from '@delta-defense/client-environments';

export enum PasswordLoginFields {
	Password = 'password'
}

const fields: Record<PasswordLoginFields, Field> = {
	[PasswordLoginFields.Password]: new Field('Password', 'Password', FieldTypes.Password, 'A password is required.', [
		required
	])
};

export const PasswordLogin = (
	auth = Auth.Instance(),
	analytics = Analytics.Instance(),
	transaction?: ITransaction,
	subscriptions = Subscriptions.Instance()
) =>
	new Step(fields, async () => {
		transaction = transaction || Transaction.Instance();

		analytics.TrackInternal({
			event_name: InternalEventNames.EnteredPassword,
			step: Steps.One
		});

		const fields = transaction.Steps[DefaultSteps.PasswordLogin].Fields;
		const email = transaction.Data.email;
		const password = fields[PasswordLoginFields.Password].GetValue();

		transaction.Message.Publish(Messages.LoggingIn);
		const loginResult = await auth.login(email, password);
		transaction.Message.Publish(Messages.Empty);
		if (loginResult.wasSuccessful) {
			const customerResult = await subscriptions.getCustomer();
			const expectedBrand = resolveMemberBrand(customerResult.value?.subscriptions || []);
			const currentBrand = shouldUseCabelasBranding() ? Brands.CabelasShield : Brands.USCCA;

			analytics.TrackInternal({
				event_name: InternalEventNames.LogInSuccess,
				step: Steps.One
			});

			if (expectedBrand !== currentBrand) {
				document.location = `${Routes.Existing}${location.search}`;
			}
			return {
				wasSuccessful: true
			};
		} else {
			transaction.Error.Publish(DismissibleErrors.ErrorLoggingIn);
			return {
				wasSuccessful: false
			};
		}
	});
